// KBarMount.tsx
import { KBarProvider, useKBar, useRegisterActions, VisualState } from 'kbar'
import { useEffect, useState } from 'react'

import { getVisibleActions } from './actions'
import { KBarModalUI } from './KBarUI'
import style from './kbar.module.scss'

let globalToggleKBar: (() => void) | null = null

export const toggleKBar = () => {
  if (globalToggleKBar) {
    globalToggleKBar()
  }
}

export const KBarBridge = (): null => {
  const { query, visualState } = useKBar(state => {
    return {
      visualState: state.visualState
    }
  })
  const [actions, setActions] = useState(() => getVisibleActions())

  // Dynamically register actions
  useRegisterActions(actions, [actions])

  useEffect(() => {
    // Set global toggle function
    globalToggleKBar = () => {
      query.toggle()
    }

    return () => {
      globalToggleKBar = null
    }
  }, [query])

  // Refresh actions whenever KBar is opened (by any method)
  useEffect(() => {
    if (visualState === VisualState.animatingIn) {
      setActions(getVisibleActions())
    }
  }, [visualState])

  return null
}

export const KBarMount = () => (
  <KBarProvider actions={[]}>
    <KBarBridge />
    <KBarModalUI />
  </KBarProvider>
)

export const KBarButton = () => (
  <button
    onClick={toggleKBar}
    className={style.kbarFooterButton}
    data-kbar-footer-button
    aria-label="Open command palette"
  >
    <span>
      <i className="icon-aytmfd-keyboard-shortcuts" />
    </span>
  </button>
)

export const KBarSpecialButton = () => (
  <button onClick={toggleKBar} className={style.kbarSpecialButton} data-kbar-main-button>
    <i className="icon-aytmfd-keyboard-shortcuts" />
  </button>
)
